"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class HandlePostsLoadingSpinner {
    constructor(container) {
        this.container = container;
        const spinner = this.container.querySelector('[data-js-map-endpoint-spinner]');
        const noPostsTemplate = this.container.querySelector('[data-js-map-no-posts-found]');
        if (spinner && noPostsTemplate) {
            this.listenForPostsDoneFetching(spinner, noPostsTemplate);
        }
    }
    listenForPostsDoneFetching(spinner, noPostsTemplate) {
        this.container.addEventListener('doneFetchingPostsEvent', (e) => {
            const pageNumber = e.detail;
            this.removeSpinner(spinner, noPostsTemplate, pageNumber);
        });
    }
    removeSpinner(spinner, noPostsTemplate, pageNumber) {
        if (pageNumber <= 1) {
            const noPostsContent = document.importNode(noPostsTemplate.content, true);
            const noPostsContainer = document.createElement('div');
            noPostsContainer.appendChild(noPostsContent);
            noPostsTemplate.insertAdjacentElement('afterend', noPostsContainer);
        }
        spinner.remove();
    }
}
exports.default = HandlePostsLoadingSpinner;
